import axios from 'axios';

export const createPartner = async (partnerData) => {
  const response = await axios.post('/api/partners', partnerData);
  return response.data.partner ?? response.data;
};

export const fetchPartner = async (partnerId) => {
  const response = await axios.get(`/api/partners/${partnerId}`);
  return response.data.partner ?? response.data;
};

export const fetchPartners = async (params = {}) => {
  const response = await axios.get('/api/partners', { params });
  return response.data.partners ?? [];
};

export const fetchPartnerApplications = async (params = {}) => {
  const response = await axios.get('/api/partners/applications', { params });
  return response.data.applications ?? [];
};

export const fetchPartnerApplication = async (applicationId) => {
  const response = await axios.get(`/api/partners/applications/${applicationId}`);
  return response.data.application ?? response.data;
};

export const approvePartnerApplication = async (applicationId, payload = {}) => {
  const response = await axios.patch(`/api/partners/applications/${applicationId}/approve`, payload);
  return response.data;
};

export const rejectPartnerApplication = async (applicationId, payload = {}) => {
  const response = await axios.patch(`/api/partners/applications/${applicationId}/reject`, payload);
  return response.data;
};

export const draftPartnerApplication = async (applicationId, payload = {}) => {
  const response = await axios.patch(`/api/partners/applications/${applicationId}/draft`, payload);
  return response.data;
};

export const deletePartnerApplication = async (applicationId) => {
  const response = await axios.delete(`/api/partners/applications/${applicationId}`);
  return response.data;
};

export const updatePartner = async (partnerId, payload = {}) => {
  const response = await axios.patch(`/api/partners/${partnerId}`, payload);
  return response.data.partner ?? response.data;
};

export const deletePartner = async (partnerId) => {
  const response = await axios.delete(`/api/partners/${partnerId}`);
  return response.data;
};
